import React from "react";
import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";

const CustomTextField = ({
  label,
  value = "",
  onChange,
  placeholder = "",
  maxLength = null,
  multiline = false,
  rows,
  minRows,
  disabled = false,
  ...props
}) => {
  const handleInput = (e) => {
    const sanitizedValue = e.target.value
      .replace(/^\s+/, "") // Remove leading spaces
      .replace(/\s{2,}/g, " "); // Replace multiple spaces with a single space
    if (sanitizedValue !== e.target.value) {
      e.target.value = sanitizedValue; // Update the input value directly
    }
  };

  return (
    <TextField
      label={label}
      value={value}
      onChange={onChange}
      onInput={handleInput} // Sanitize input here
      placeholder={placeholder}
      variant="outlined" // You can choose "filled" or "standard" as well
      fullWidth
       size="small"
      inputProps={{ maxLength }} // Set the maxLength attribute here
      multiline={multiline} // Enable multiline
      rows={rows} // Set the number of rows (if multiline)
      minRows={minRows} // Set the minimum number of rows (if multiline)
      disabled={disabled} // Set the disabled attribute here
      {...props}
    />
  );
};

CustomTextField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  //onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  multiline: PropTypes.bool, // Prop type for multiline
  rows: PropTypes.number, // Prop type for rows
  minRows: PropTypes.number, // Prop type for minRows
  disabled: PropTypes.bool, // Prop type for disabled
};

export default CustomTextField;
